import { useCallback, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  Container,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@mui/material';
import Page from '../components/Page';
import { adminApi } from 'src/utils/adminApi';

export default function AdminUsers() {
  const [search, setSearch] = useState('');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const loadUsers = useCallback(() => {
    setLoading(true);
    setError('');
    adminApi
      .listUsers({ q: search, sort: 'created_at', direction: 'desc', page: 1, per_page: 100 })
      .then((result) => {
        const items = (result.data?.items || []).filter(
          (user) => !(user.roles || []).includes('player')
        );
        setRows(items);
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [search]);

  useEffect(() => {
    loadUsers();
  }, [loadUsers]);

  return (
    <Page title={`Users | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container maxWidth="lg">
        <Box sx={{ py: 3 }}>
          <Typography variant="h4" sx={{ color: '#F3F4F6', mb: 3 }}>
            Users
          </Typography>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} md={8}>
              <TextField
                fullWidth
                placeholder="Search by name or email"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Button fullWidth variant="contained" sx={{ height: 56 }} onClick={loadUsers}>
                Search
              </Button>
            </Grid>
          </Grid>
          {error && <Typography sx={{ color: '#F87171', mb: 2 }}>{error}</Typography>}
          <Card sx={{ bgcolor: '#151921', border: '1px solid #232935' }}>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    {['Name', 'Email', 'Roles', 'Status'].map((head) => (
                      <TableCell key={head}>{head}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {!loading && rows.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        No admin users found.
                      </TableCell>
                    </TableRow>
                  )}
                  {rows.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell sx={{ color: '#F3F4F6' }}>{row.name}</TableCell>
                      <TableCell>{row.email}</TableCell>
                      <TableCell>{(row.roles || []).join(', ') || '—'}</TableCell>
                      <TableCell>{row.isBlocked ? 'Locked' : 'Active'}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Box>
      </Container>
    </Page>
  );
}
